import { TOOLTIP_LOCATIONS } from 'utils/tooltipHelpers'

export const TOOLTIP_MAP = {
  'Units 1-4': TOOLTIP_LOCATIONS.SITE_LESSONS,
  'Unit 1': TOOLTIP_LOCATIONS.SITE_UNIT_1,
  'Unit 2': TOOLTIP_LOCATIONS.SITE_UNIT_2,
  'Unit 3': TOOLTIP_LOCATIONS.SITE_UNIT_3,
  'Unit 4': TOOLTIP_LOCATIONS.SITE_UNIT_4,
}
